import { msg } from '@lingui/core/macro';
import { TASK_SCALE_TYPE } from '@routes/sidebar/___shared___/constants.ts';

export const ELEMENT_TYPE = 'type';
export const ELEMENT_ID = 'id';
export const ELEMENT_CREATOR_REFERENCE = 'creatorReference';
export const ELEMENT_CREATED_BY = 'creator';
export const ELEMENT_CREATED_FOR = 'createdFor';
export const ELEMENT_TITLE = 'title';
export const ELEMENT_LEARNING_OBJECTIVE = 'learningObjective';
export const BACK_ELEMENT_TITLE = 'Title';
export const ELEMENT_RUN_TIME_MINUTES = 'runTimeMinutes';
export const ELEMENT_RUN_TIME_SECONDS = 'runTimeSeconds';
export const ELEMENT_TYPE_PDF_KEY = 'PDF';
export const ELEMENT_TYPE_VIDEO_KEY = 'Video';
export const ELEMENT_TYPE_YOU_TUBE_KEY = 'YouTube';
export const ELEMENT_TYPE_TASK_KEY = 'Task';
export const ELEMENT_TASK_RATING_SCALE = 'taskScaleType';
export const ELEMENT_TASK_SUBTASKS = 'subTasks';
export const ELEMENT_TASK_REFERENCE = 'referenceText';
export const SUBTASK_DESCRIPTION = 'subtaskDescription';
export const ASSESSOR_GUIDELINE = 'assessorGuideline';
export const ELEMENT_PDF_DOCUMENT = 'pdfDocument';
export const ELEMENT_COVER_IMAGE = 'thumbnailURI';
export const ELEMENT_VIDEO = 'video';
export const ELEMENT_YOU_TUBE = 'youTube';
export const ELEMENT_QUESTIONS = 'itemQuizQuestions';
export const ELEMENT_QUESTION = 'question';
export const ELEMENT_TITLE_MAP: Record<string, string> = {
    [ELEMENT_TITLE]: 'Title',
};
export const ELEMENT_TYPES = {
    [ELEMENT_TYPE_PDF_KEY]: msg`PDF`,
    [ELEMENT_TYPE_VIDEO_KEY]: msg`Video`,
    [ELEMENT_TYPE_YOU_TUBE_KEY]: msg`YouTube`,
    [ELEMENT_TYPE_TASK_KEY]: msg`Task`,
};
export const ELEMENT_TASK_RATING_SCALES = {
    [TASK_SCALE_TYPE.TwoPointApprove]: msg`2-point (Approved / Disapproved)`,
    [TASK_SCALE_TYPE.TwoPointConfidence]: msg`2-point (Confident / Not Confident)`,
    [TASK_SCALE_TYPE.FivePointCompetence]: msg`5-point – Competency (BCAV / ICMG)`,
};
export const MAX_PDF_SIZE_MB = 15;
export const MAX_VIDEO_SIZE_MB = 350;
export const MAX_PDF_SIZE_BYTES = MAX_PDF_SIZE_MB * 1024 * 1024;
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024;

// Input limits of the element form. The Cypress specs import them, so keep the texts in the form in sync.
export const ELEMENT_TITLE_MAX_LENGTH = 78;
export const ELEMENT_LEARNING_OBJECTIVE_MAX_LENGTH = 512;
export const ELEMENT_CREATOR_REFERENCE_MAX_LENGTH = 20;

export const ELEMENT_ENTITY_TYPE = 'ElementAdmin' as const;

export const ELEMENT_VALIDATION_FIELDS_NAMES = {
    // only backend validation fields
    TITLE: 'Title',
    LEARNING_OBJECTIVE: 'LearningObjective',
} as const;

export const SHARED_ELEMENT_FORM_SELECT_UPLOAD_PDF_DOCUMENT = msg`Select and upload PDF document`;
export const SHARED_ELEMENT_FORM_PLACEHOLDER = msg`Select PDF document (Max size: 15 MB)`;
export const SHARED_ELEMENT_FORM_BUTTON = msg`Select`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK = msg`YouTube link`;
export const SHARED_ELEMENT_FORM_PLACEHOLDER_ENTER_YOUTUBE_LINK = msg`Enter YouTube link`;
export const SHARED_ELEMENT_FORM_BUTTON_ADD_LINK = msg`Add link`;
export const SHARED_ELEMENT_FORM_UPLOAD_VIDEO = msg`Upload video`;
export const SHARED_ELEMENT_FORM_PLACEHOLDER_SELECT_MP4_FILE_MAX = msg`Select mp4 file (Max size: 350 MB)`;
export const SHARED_ELEMENT_FORM_REMOVE = msg`Remove`;
export const SHARED_ELEMENT_FORM_UPLOAD = msg`Upload`;
export const SHARED_ELEMENT_FORM_CHANGE = msg`Change`;
export const SHARED_ELEMENT_FORM_FILE_REQUIRED = msg`File is required`;
export const SHARED_ELEMENT_FORM_PDF_UPLOADED = msg`PDF file uploaded`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK_REQUIRED = msg`YouTube link is required`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK_NOT_VERIFIED = msg`Verify link first by clicking Add link button.`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK_ADDED = msg`YouTube link added`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK_BROKEN_TITLE = msg`YouTube link doesn't work`;
export const SHARED_ELEMENT_FORM_YOUTUBE_LINK_BROKEN_DESCRIPTION = msg`The YouTube link appears to be broken or the video has been removed.`;
export const SHARED_ELEMENT_FORM_ENTER_PLACEHOLDER = msg`Enter`;
export const SHARED_ELEMENT_FORM_CREATOR_REFERENCE = msg`Creator reference`;
export const SHARED_ELEMENT_FORM_TYPE_REQUIRED = msg`Element type is required`;
export const SHARED_ELEMENT_FORM_CREATED_BY_REQUIRED = msg`Created by is required`;
export const SHARED_ELEMENT_FORM_CREATED_FOR_REQUIRED = msg`Created for is required`;
export const SHARED_ELEMENT_FORM_NO_THUMBNAIL_ALT = msg`No thumbnail image`;
export const SHARED_ELEMENT_FORM_THUMBNAIL_ALT = msg`Thumbnail image`;
